// Définition d'un convertisseur personnalisé pour la date
export const dateConverter = {
    fromAttribute(value) {
        // Convertit une chaîne d'attribut en objet Date
        return value ? new Date(value) : null;
    },
    toAttribute(value) {
        // Convertit un objet Date en chaîne pour l'attribut
        return value instanceof Date ? value.toISOString() : null;
    },
};
//# sourceMappingURL=date-converter.js.map